<!--  -->
<template>
  <div>
    <div>
      <el-input
        v-model="adqAdvertListParams.account_id"
        clearable
        style="width:240px;margin-right:10px"
        placeholder="请输入广告主ID"
      />
      <el-input
        v-model="adqAdvertListParams.advertiser_name"
        clearable
        style="width:240px;margin-right:10px"
        placeholder="请输入广告主名称"
      />
      <el-input
        v-model="adqAdvertListParams.project_id"
        clearable
        style="width:240px;margin-right:10px"
        placeholder="请输入项目ID"
      />
      <el-input
        v-model="adqAdvertListParams.name"
        clearable
        style="width:240px;margin-right:10px"
        placeholder="请输入项目名称"
      />
      <el-button
        type="primary"
        style="margin-left:10px"
        icon="el-icon-search"
        @click="sraw"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh"
        @click="awered"
      >重置</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="adqAdvertList"
      highlight-current-row
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      class="border-gray"
      fit
      style="width: 100%; justify-content: space-between;margin-top:20px"
    >
      <el-table-column
        prop="account_id"
        label="广告主id"
        align="center"
        width="200"
      />
      <el-table-column
        prop="advertiser_name"
        label="广告主名称"
        align="center"
        width="300"
      />
      <el-table-column
        prop="name"
        label="项目名称"
        align="center"
        width="300"
      />
      <el-table-column
        prop="project_id"
        label="项目ID"
        align="center"
        width="300"
      />
      <el-table-column
        prop="created_at"
        label="操作"
        align="center"
        width="250"
        fixed="right"
      >
        <template scope="scope">
          <el-button
            type="primary"
            icon="el-icon-success"
            size="mini"
            @click="handlechooseTencentAdqAdver(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      :page-sizes="[10]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { projectIndex } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      loading: false,
      adqAdvertList: [],
      total: null,
      adqAdvertListParams: {
        account_id: null,
        advertiser_name: null,
        project_id: null,
        name: '',
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    send() {
      this.fetchAdqAdvertList()
    },
    // 获取广告列表
    fetchAdqAdvertList() {
      this.loading = true
      projectIndex(this.adqAdvertListParams).then(res => {
        console.log('res:', res)
        this.adqAdvertList = res.data.list
        this.total = res.data.count
        this.loading = false
      })
    },
    handlechooseTencentAdqAdver(item) {
      console.log(item)
      this.$emit('callbackr', item)
    },
    fetchPageSize(e) {
      console.log('11', e)
      this.adqAdvertListParams.page_size = e
      this.fetchAdqAdvertList()
    },
    fetchCurrentPage(e) {
      console.log('22', e)
      this.adqAdvertListParams.page = e
      this.fetchAdqAdvertList()
    },
    sraw() {
      this.adqAdvertListParams.page = 1
      this.fetchAdqAdvertList()
    },
    awered() {
      this.adqAdvertListParams.page = 1
      this.adqAdvertListParams.account_id = null
      this.adqAdvertListParams.advertiser_name = null
      this.adqAdvertListParams.project_id = null
      this.adqAdvertListParams.name = null
      this.fetchAdqAdvertList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
